"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { ScrollArea } from "../ScrollArea/index.js";
function DialogBody({ children, className, slots }) {
    return /*#__PURE__*/ jsx(ScrollArea, {
        dialogBody: true,
        className: cn('flex-1', className),
        slots: slots,
        children: children
    });
}
export { DialogBody };
